import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const SplashRevolutionary = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/onboarding-new');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-black relative overflow-hidden flex items-center justify-center">
      {/* Animated Background */}
      <div className="absolute inset-0">
        {/* Radial gradient */}
        <motion.div
          className="absolute inset-0"
          animate={{
            background: [
              'radial-gradient(circle at 50% 50%, rgba(147,51,234,0.4) 0%, rgba(0,0,0,1) 70%)',
              'radial-gradient(circle at 50% 50%, rgba(236,72,153,0.4) 0%, rgba(0,0,0,1) 70%)',
              'radial-gradient(circle at 50% 50%, rgba(59,130,246,0.4) 0%, rgba(0,0,0,1) 70%)',
              'radial-gradient(circle at 50% 50%, rgba(147,51,234,0.4) 0%, rgba(0,0,0,1) 70%)',
            ]
          }}
          transition={{ duration: 10, repeat: Infinity }}
        />

        {/* Twinkling stars */}
        {[...Array(100)].map((_, i) => (
          <motion.div
            key={i}
            className="absolute w-1 h-1 bg-white rounded-full"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
            }}
            animate={{
              opacity: [0, 1, 0],
              scale: [0, 1.5, 0]
            }}
            transition={{
              duration: 2 + Math.random() * 3,
              repeat: Infinity,
              delay: Math.random() * 5
            }}
          />
        ))}
      </div>

      {/* Logo Container */}
      <div className="relative z-10 text-center px-8">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, type: 'spring', bounce: 0.5 }}
        >
          <img 
            src="/taraanaya-logo-transparent.png" 
            alt="Taraanaya" 
            className="w-64 mx-auto mb-8"
          />
        </motion.div>

        <motion.h1
          className="text-4xl font-bold text-white mb-3"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          Taraanaya
        </motion.h1>

        <motion.p
          className="text-lg text-white/70 mb-8"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.8 }}
        >
          Your Astrological Intelligence
        </motion.p>

        {/* Loading animation */}
        <motion.div
          className="flex gap-2 justify-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
        >
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-3 h-3 bg-purple-400 rounded-full"
              animate={{
                y: [0, -15, 0],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{
                duration: 1,
                repeat: Infinity,
                delay: i * 0.2
              }}
            />
          ))}
        </motion.div>
      </div>

      {/* Bottom text */}
      <motion.div
        className="absolute bottom-8 left-0 right-0 text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5 }}
      >
        <p className="text-white/50 text-sm">
          Professional Vedic Astrology
        </p>
      </motion.div>
    </div>
  );
};

export default SplashRevolutionary;
